import {Component, ElementRef, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Host, Menu, MenuGroup, AppService, Table, TableType} from "../../../../common";
import {Cart} from "../../../../common";

@Component({
  standalone: false,
  template: `
    <app-header [host]="host" [cart]="cart"></app-header>
    <breadcrumb [group]="group"></breadcrumb>
    <main id="t4dmain" class="container d-flex flex-column" *ngIf="group">
      <!-- home greeter (if we are on home) -->
      <home-greeter [host]="host" *ngIf="!group.parent"></home-greeter>
      <!-- opening hours warning -->
      <opening-hours-warning [host]="host" [table]="table" *ngIf="!group.parent"></opening-hours-warning>
      <!-- the flat menu -->
      <flat-menu [host]="host" [cart]="cart" [menu]="menu" *ngIf="flatMode" class="flex-grow-1"></flat-menu>
      <!-- the menu group -->
      <menu-group [host]="host" [cart]="cart" [group]="group" *ngIf="!flatMode" class="flex-grow-1"></menu-group>
      <app-footer [host]="host" *ngIf="!group.parent && host.show_footer"></app-footer>
    </main>
    <service-call *ngIf="showServiceCall"></service-call>
  `
})

export class MenuGroupPage implements OnInit {

  host: Host = null;
  table: Table = null;
  menu: Menu = null;
  cart: Cart = null;
  group: MenuGroup;
  isFrontPage: boolean;
  flatMode: boolean;
  showServiceCall: boolean;
  TableType = TableType;

  constructor(
    private route: ActivatedRoute,
    public appService: AppService,
    private elementRef: ElementRef
  ) {
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const group_id = parseInt(params.get('grpid'))
      this.appService
        .load()
        .subscribe(({host, menu, table, cart}) => {
          this.host = host;
          this.menu = menu;
          this.table = table;
          this.group = (group_id) ? this.menu.groups[group_id] : this.menu.root;
          this.isFrontPage = !this.group.parent;
          this.flatMode = this.isFrontPage && this.host.flat_mode;
          this.showServiceCall = host.allow_waiter_call && this.isFrontPage
                                    && table.type == TableType.inhouse && this.appService.getOrdersEnabled()
          this.cart = cart;
          // the main element isn't there yet, but after setTimeout it is
          window.setTimeout(() => {
            if (this.elementRef?.nativeElement) {
              const main = this.elementRef.nativeElement.querySelector('main');
              if (main) {
                main.scrollTop = 0;
              }
            }
            // hack into top navigation to scroll to top
            if (this.flatMode) {
              document.querySelector('.home-link').addEventListener('click', (e) => {
                const t4dmain = this.elementRef.nativeElement.querySelector('main');
                if (t4dmain && getComputedStyle(t4dmain).overflowY == 'auto') {
                  t4dmain.scrollTo({top: 0, behavior: 'smooth'});
                } else {
                  window.scrollTo({top: 0, behavior: 'smooth'});
                }
              });
            }
          });
        });
    });
  }
}
